import React, { FC, useState } from 'react';
import Container from '../components/layout/Container';
import HistoricalFinish from '../components/data/HistoricalFinish';
import SpendingByPosition from '../components/data/SpendingByPosition';
import TradesChart from '../components/data/TradesChart';
import RosterSwarmPlot from '../components/data/RosterSwarmPlot';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

const Home : FC = () => {
  const [announcementsOpen, setAnnouncementsOpen] = useState(false);

  return (
    <Container testId='home-page'>
      <div className="shadow-lg bg-white rounded-md mt-4 overflow-hidden">
        <button
          type="button"
          className="w-full flex items-center justify-between px-6 py-4 text-left"
          onClick={() => setAnnouncementsOpen((o) => !o)}
        >
          <span className="text-base font-semibold text-gray-900">League Notes & Announcements</span>
          {announcementsOpen
            ? <ChevronUpIcon className="h-5 w-5 text-gray-400" />
            : <ChevronDownIcon className="h-5 w-5 text-gray-400" />
          }
        </button>
        {announcementsOpen && (
          <div className="px-6 pb-6 text-sm text-gray-500 border-t border-gray-100 pt-4">
            <h2 className="text-lg font-semibold text-gray-900">Welcome to the Invitational</h2>
            <div>
                <h3 className="text-md font-semibold text-gray-900">Links</h3>
                <ul className="list-disc list-inside">
                  <li><a href="https://docs.google.com/document/d/1uuva-NbfQSsfSVSiKqou0a3xpRafY9a5KpnrL8iDiFA/edit?ouid=109566351773128100687&usp=docs_home&ths=true" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-900">League Constitution</a></li>
                  <li><a href="https://football.fantasysports.yahoo.com/league/invitationaldl" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-900">League Yahoo Page</a></li>
                  <li><a href="https://docs.google.com/forms/d/e/1FAIpQLSdyZpwUN1eqji1IeiEfsM-fj38xZSq42zB8YT0ti5Yoo_X7mA/viewform?usp=preview" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-900">Feedback Form</a></li>
                  <li><a href="https://docs.google.com/document/d/1yskBSrcgsEufQtZXa7qfAU92TcBsczsQ-CIgXvfS7u0/edit?tab=t.0" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-900">Draft Day Order of Events</a></li>
                </ul>
            </div>
          </div>
        )}
      </div>
      <div className="mt-4" />
      <HistoricalFinish />
      <div className="flex flex-col lg:flex-row lg:space-x-4">
        <div style={{ height: 400 }} className='shadow-lg bg-white rounded-md p-6 mt-4 w-full lg:w-1/2 overflow-hidden'>
          <SpendingByPosition />
        </div>
        <div style={{ height: 400 }} className='shadow-lg bg-white rounded-md p-6 mt-4 w-full lg:w-1/2 overflow-hidden'>
          <TradesChart />
        </div>
      </div>
      <div className='shadow-lg bg-white rounded-md p-6 mt-4 overflow-scroll'>
        <RosterSwarmPlot />
      </div>
    </Container>
  )
}

export default Home


